import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from '../views/NotFound'
import AuthorizationView from '../views/AuthorizationView'
import UserProfileView from '../views/UserProfileView'
import UserRegistrationView from '../views/UserRegistrationView'
import ConfirmEmailRegistrationView from '../views/ConfirmEmailRegistrationView'
import PolicyView from '../legal/PolicyView'
import ConfidentionalView from '../legal/ConfidentionalView'
import TermsOfUseView from '../legal/TermsOfUseView'
import CalendarView from '../views/CalendarView'
import FriendsView from '../views/FriendsView'

// import SettingsView from '../views/SettingsView'
// import EditUserView from '../views/EditUserView'
// import NewsSourcesView from '../views/NewsSourcesView'
// import CreateNewsSourceView from '../views/CreateNewsSourceView'
// import NewsPostsView from '../views/NewsPostsView'
// import EditNewsSourceView from '../views/EditNewsSourceView'

Vue.use(VueRouter)

const DEFAULT_TITLE = '';

const routes = [
  // {
  //   path: '/',
  //   name: 'logout',
  //   component: AuthorizationView,
  //   meta: { title: 'Авторизация' }
  // },
  {
    path: '/login',
    name: 'login',
    component: AuthorizationView,
    meta: { title: 'Авторизация' }
  },
  {
    path: '/legal/confidentional',
    name: 'confidentional',
    component: ConfidentionalView,
    meta: { title: 'Политика конфиденциальности' }
  },
  {
    path: '/legal/termsofuse',
    name: 'termsofuse',
    component: TermsOfUseView,
    meta: { title: 'Политика конфиденциальности' }
  },
  {
    path: '/policy',
    name: 'policy',
    component: PolicyView,
    meta: { title: 'Политика конфиденциальности' }
  },
  {
    path: '/register',
    name: 'register',
    component: UserRegistrationView,
    meta: { title: 'Регистрация' }
  },
  {
    path: '/confirm-email-registration',
    name: 'confirm-email-registration',
    component: ConfirmEmailRegistrationView,
    meta: { title: 'Подтверждение регистрации' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: UserProfileView,
    meta: { 
      title: 'Профиль пользователя',
      // auth: true, // A protected route
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: CalendarView,
    meta: {
      title: 'Календарь событий',
    }
  },
  {
    path: '/friends',
    name: 'friends',
    component: FriendsView,
    meta: {
      title: 'Друзья',
      auth: true, // A protected route
    }
  },
  // {
  //   path: '/timetable-sources',
  //   name: 'timetable-sources',
  //   component: NewsSourcesView,
  //   meta: {
  //     title: 'timetable Источники',
  //     auth: true,
  //   }
  // },
  // {
  //   path: '/create-timetable-source',
  //   name: 'create-timetable-source',
  //   component: CreateNewsSourceView,
  //   meta: {
  //     title: 'Добавление timetable источника',
  //     auth: true,
  //   }
  // },
  // {
  //   path: '/edit-timetable-source',
  //   name: 'edit-timetable-source',
  //   component: EditNewsSourceView,
  //   meta: {
  //     title: 'Редактирование timetable источника',
  //     auth: true,
  //   }
  // },
  // {
  //   path: '/timetable',
  //   name: 'timetable',
  //   component: NewsPostsView,
  //   meta: {
  //     title: 'timetable',
  //     // Todo: может быть доступно без авторизации
  //     auth: true,
  //   }
  // },
  {
    path: "/:notFound",
    component: NotFound,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  fullPathRedirect: true,
  redirect: {
    profile: '/profile',
    login: '/login',
    logout: '/',
  },
});

export default router
